/**
 * When a plan draft may be saved and published — including when it is EMPTY.
 *
 * Ed, 2026-09-24: deleting the last item left Save disabled, AND the autosave
 * silently skipped the emptied draft, so the stored draft still held the item
 * and it "came back" next visit — to a novice, the delete hadn't worked. There
 * was no architectural reason: an empty version writes an empty goal list and
 * nothing downstream needs at least one item (a plan with nothing on it asks
 * the carer for nothing).
 *
 * Pure, so the rules are tested directly.
 */

/** The draft has no goals and no monitored events. */
export function isEmptyPlan(goals: number, monitoredEvents: number): boolean {
  return goals === 0 && monitoredEvents === 0;
}

/**
 * Autosave what is on screen — an emptied draft included — so the stored
 * draft always matches what the planner last saw. The one skip: a brand-new
 * plan that has never had anything on it (no stored draft, no live version),
 * where there is nothing to keep.
 */
export function shouldSaveDraft(empty: boolean, hasDraft: boolean, hasLiveVersion: boolean): boolean {
  return !empty || hasDraft || hasLiveVersion;
}

/**
 * Publishing an empty version is allowed when it REPLACES a live one: that is
 * how a planner takes everything off a plan. A brand-new plan with nothing on
 * it has nothing to publish.
 */
export function canPublish(empty: boolean, hasLiveVersion: boolean): boolean {
  return !empty || hasLiveVersion;
}
